import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('Group', {
    staticClass: "DatetimeRange"
  }, [_c('Cell', [_c('div', {
    style: {
      position: 'relative',
      width: _vm.labelWidth + 'rem'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm.required ? _c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.name) + " ")]), _c('span')]), _c('div', {
    staticClass: "flex-row"
  }, [_c('Datetime', {
    staticClass: "flex-date",
    attrs: {
      "format": _vm.format,
      "placeholder": i18n.tc("237")
    },
    model: {
      value: _vm.formatValueLeft,
      callback: function ($$v) {
        _vm.formatValueLeft = $$v;
      },
      expression: "formatValueLeft"
    }
  }), _c('Datetime', {
    staticClass: "flex-date",
    attrs: {
      "format": _vm.format,
      "placeholder": i18n.tc("237")
    },
    model: {
      value: _vm.formatValueRigth,
      callback: function ($$v) {
        _vm.formatValueRigth = $$v;
      },
      expression: "formatValueRigth"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };